import { createVNode as i, mergeProps as n } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/DictionaryManageFilledStandard.js";
import d from "../components/PfIcon.js";
const a = (r, t) => {
  const e = {
    ...r,
    ...t.attrs
  };
  return i(d, n(e, {
    icon: o
  }), null);
};
a.displayName = "DictionaryManageFilledStandard";
a.inheritAttrs = !1;
export {
  a as default
};
